<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            :title="isCreateMode ? 'ADD RM CODE' : 'UPDATE RM CODE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-carrier-popup" @submit.prevent="handleSubmit(onClickCreateProductionCode)" autocomplete="off">

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="prefix" name="prefix" rules="required" v-slot="{ errors }">
                <small class="label">Prefix</small>
                <vs-input v-model="form.prefix"  name="prefix" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-input v-model="form.description"  name="description" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-raw-material-codes-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        description: '',
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'CreateRawMaterialCodePopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup() {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
        } catch (error) {

        }
      },
      async onClickCreateProductionCode() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-carrier-popup',
          scale: 0.45
        })
        try {
          await SupplierRawMaterialRepository.createRawMaterialCode(this.form);
          this.showSuccessMessage('RM code added successfully');
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-carrier >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
